import {
  getApprovalAuthorities, postApprovalAuthority, putApprovalAuthority,
} from '../../../Api/services/backoffice';

export const key = 'approvalAuthority';

const entityName = {
  singular: 'Cargo de Usuário',
  plural: 'Cargs de Usuários',
};

const queries = {
  list: { key, fn: getApprovalAuthorities },
  detail: { key },
};

const mutations = {
  create: postApprovalAuthority,
  update: putApprovalAuthority,
};

const fields = {
  table: [
    { key: 'code', label: 'Código' },
    { key: 'approver', label: 'Cargo' },
  ],
};

export const listConfig = {
  title: entityName.plural,
  tableFields: fields.table,
  searchFields: fields.search,
  queryConfig: queries.list,
};

export const createConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.create,
};

export const updateConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.update,
  queryConfig: queries.detail,
};
